import React, { useState, useEffect } from "react";
import {
  Grid,
  Typography,
  TextField,
  Button,
  Paper,
  Dialog,
  DialogContent,
  DialogTitle,
  Autocomplete,
  Box,
  IconButton,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import CancelIcon from "@mui/icons-material/Cancel";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { updateBillById } from "../Redux/actionCreator";
import { uploadPhoto } from "../../../services/eventServices";
import { setPhoto } from "../../../layouts/events/Redux/actionCreator";
import { toast } from "react-toastify";
import CloseIcon from "@mui/icons-material/Close";

const paymentMethods = [
  { label: "Cash", value: "cash" },
  { label: "Bank Transfer", value: "bankTransfer" },
  { label: "UPI", value: "upi" },
  { label: "Cheque", value: "cheque" },
];

const bankAccounts = [
  { label: "HDFC Bank", value: "hdfc" },
  { label: "ICICI Bank", value: "icici" },
  { label: "SBI Bank", value: "sbi" },
];

const AddPayment = ({
  billId,
  billNumber,
  totalAmount,
  billData,
  open,
  handleClosePayment,
}) => {
  const dispatch = useDispatch();

  const [formData, setFormData] = useState({
    amountReceivedAgainstBill: "",
    amountReceiveDate: "",
    paymentMethods: "",
    chequeNumber: "",
    chequeDate: "",
    UPIReferenceNumber: "",
    transactionAmountReceivedInBank: "",
    bankUTRNo: "",
    jobizoBankName: "ICICI Bank - ****0512",
    TDSAmount: "",
    bankNarration: "",
    attachmentURL: null,
    attachment: null,
  });

  // console.log("billData", billData);

  const [formErrors, setFormErrors] = useState({});

  useEffect(() => {
    if (billData?.offlineBillDetails) {
      setFormData((prev) => ({
        ...prev,
        ...billData.offlineBillDetails,
        billNumber: billNumber || "",
        totalAmount: totalAmount || "",
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        billNumber: billNumber || "",
        totalAmount: totalAmount || "",
      }));
    }
  }, [billData, billNumber, totalAmount]);

  const handleChange = async (e) => {
    const { name, value, files } = e.target;
    // console.log("files", files);
    if (files && files[0]) {
      const file = files[0];
      // Upload the file immediately after selection
      // setSelectedFileName(file.name);
      dispatch(setPhoto(file))
        .then((response) => {
          const logoUrl = response.payload.data.data[0].url;
          setFormData({
            ...formData,
            attachmentURL: logoUrl,
            attachment: file,
          });
          setFormErrors({ ...formErrors, attachmentURL: "" });
        })
        .catch((error) => {
          console.error("Error uploading file:", error);
          // Handle error
        });
    } else {
      // setFormData({ ...formData, [name]: value });
      // setFormErrors({ ...formErrors, [name]: "" });
      // Handle text/number input
      let newValue = value;

      // Ensure value is not negative for amountReceivedAgainstBill
      if (name === "amountReceivedAgainstBill" && parseFloat(value) < 0) {
        newValue = "0";
      }

      // Update form data
      setFormData((prevData) => ({
        ...prevData,
        [name]: newValue,
      }));
      const pendingAmount =
        billData?.amount -
        (parseFloat(
          billData?.offlineBillDetails?.amountReceivedAgainstBill || 0
        ) +
          parseFloat(billData?.offlineBillDetails?.TDSAmount || 0));
      // Validate amountReceivedAgainstBill against totalAmount
      if (
        name === "amountReceivedAgainstBill" &&
        parseFloat(value) > pendingAmount
      ) {
        setFormErrors((prevErrors) => ({
          ...prevErrors,
          amountReceivedAgainstBill:
            "Amount received against this bill cannot be more than remaining amount.",
        }));
      } else {
        setFormErrors((prevErrors) => ({
          ...prevErrors,
          [name]: "",
        }));
      }
    }
  };

  // console.log("formData", formData);

  const validate = () => {
    const errors = {};
    if (!formData.amountReceivedAgainstBill)
      errors.amountReceivedAgainstBill = "Received Amount is required";
    if (!formData.amountReceiveDate)
      errors.amountReceiveDate = "Receive Date is required";
    if (!formData.paymentMethods)
      errors.paymentMethods = "Payment method is required";
    if (formData.paymentMethods === "cheque") {
      if (!formData.chequeNumber)
        errors.chequeNumber = "Cheque number is required";
      if (!formData.chequeDate) errors.chequeDate = "Cheque date is required";
    }
    if (formData.paymentMethods === "bankTransfer" && !formData.bankUTRNo)
      errors.bankUTRNo = "UTR number is required";
    if (formData.paymentMethods === "upi" && !formData.UPIReferenceNumber)
      errors.UPIReferenceNumber = "UPI reference is required";
    if (!formData.transactionAmountReceivedInBank)
      errors.transactionAmountReceivedInBank =
        "Received Transaction amount is required";
    if (!formData.jobizoBankName)
      errors.jobizoBankName = "Bank account is required";
    if (!formData.TDSAmount) errors.TDSAmount = "TDS amount is required";
    // if (!formData.bankNarration)
    //   errors.bankNarration = "Bank narration is required";
    if (!formData.attachmentURL && formData.paymentMethods === "cheque")
      errors.attachmentURL = "Attachment is required";

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  // console.log("billId", billId);

  // console.log("formErrors", formErrors);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validate()) return;

    const payload = {
      amountReceivedAgainstBill: formData.amountReceivedAgainstBill,
      amountReceiveDate: formData.amountReceiveDate,
      paymentMethods: formData.paymentMethods,
      chequeNumber: formData.chequeNumber,
      chequeDate: formData.chequeDate,
      UPIReferenceNumber: formData.UPIReferenceNumber,
      transactionAmountReceivedInBank: formData.transactionAmountReceivedInBank,
      bankUTRNo: formData.bankUTRNo,
      jobizoBankName: formData.jobizoBankName,
      TDSAmount: formData.TDSAmount,
      bankNarration: formData.bankNarration,
      attachmentURL: formData.attachmentURL,
    };

    dispatch(updateBillById({ id: billId, payload: payload })).then(() => {
      // console.log("Submitted payload:", payload);
      handleClosePayment();
      window.location.reload();
    });
  };

  const completePayment =
    billData?.amount -
    (parseFloat(billData?.offlineBillDetails?.amountReceivedAgainstBill || 0) +
      parseFloat(billData?.offlineBillDetails?.TDSAmount || 0));

// console.log("completePayment", completePayment);

  return (
    <Dialog
      open={open}
      // onClose={handleClosePayment}
      onClose={() => {}}
      disableEscapeKeyDown
      BackdropProps={{
        onClick: (e) => e.stopPropagation(),
      }}
      maxWidth="sm"
      fullWidth
    >
      {/* <DialogTitle
        sx={{
          fontWeight: "bold",
          color: "white",
          //   bgcolor: "#1a237e",
          borderRadius: "4px 4px 0 0",
          py: 1.5,
        }}
      >
        Add Payment
      </DialogTitle> */}
      <DialogTitle
        sx={{
          fontWeight: "bold",
          color: "white",
          borderRadius: "4px 4px 0 0",
          py: 1.5,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        Add Payment
        <IconButton
          aria-label="close"
          onClick={handleClosePayment}
          sx={{
            position: "absolute",
            right: 2,
            top: -1,
            color: "grey.600",
            "&:hover": {
              color: "black",
              backgroundColor: "rgba(0,0,0,0.1)",
              borderRadius: "50%",
            },
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ backgroundColor: "#fafafa" }}>
        <Paper
          elevation={0}
          sx={{ p: 3, borderRadius: 2, background: "transparent" }}
        >
          <form onSubmit={handleSubmit}>
            <Grid container spacing={2}>
              {/* Bill Number */}
              <Grid item xs={6}>
                <TextField
                  fullWidth
                  label="Bill Number"
                  name="billNumber"
                  value={formData.billNumber}
                  disabled
                />
              </Grid>

              {/* Total Amount */}
              <Grid item xs={6}>
                <TextField
                  fullWidth
                  label="Total Amount"
                  name="totalAmount"
                  value={formData.totalAmount}
                  disabled
                />
              </Grid>

              {/* Amount Received */}
              <Grid item xs={6}>
                <TextField
                  fullWidth
                  required
                  type="number"
                  label="Amount Received Against This Bill"
                  name="amountReceivedAgainstBill"
                  value={formData.amountReceivedAgainstBill}
                  onChange={handleChange}
                  sx={{
                    flex: 1,
                    "& input[type=number]::-webkit-inner-spin-button": {
                      display: "none",
                    },
                    "& input[type=number]::-webkit-outer-spin-button": {
                      display: "none",
                    },
                    "& input[type=number]": {
                      MozAppearance: "textfield",
                    },
                  }}
                  InputLabelProps={{
                    sx: {
                      "& .MuiInputLabel-asterisk": {
                        color: "red",
                      },
                    },
                  }}
                  error={!!formErrors.amountReceivedAgainstBill}
                  helperText={formErrors.amountReceivedAgainstBill}
                />
              </Grid>

              {/* Date */}
              <Grid item xs={6}>
                <TextField
                  fullWidth
                  required
                  type="date"
                  label="Date (Amount Received)"
                  name="amountReceiveDate"
                  value={formData.amountReceiveDate}
                  onChange={handleChange}
                  // InputLabelProps={{ shrink: true }}
                  InputLabelProps={{
                    shrink: true,
                    sx: {
                      "& .MuiInputLabel-asterisk": {
                        color: "red",
                      },
                    },
                  }}
                  inputProps={{
                    max: new Date().toISOString().split("T")[0],
                  }}
                  error={!!formErrors.amountReceiveDate}
                  helperText={formErrors.amountReceiveDate}
                />
              </Grid>

              {/* Payment Method (Dropdown) */}
              <Grid item xs={12}>
                <Autocomplete
                  options={paymentMethods}
                  getOptionLabel={(option) => option.label}
                  value={
                    paymentMethods.find(
                      (opt) => opt.value === formData.paymentMethods
                    ) || null
                  }
                  onChange={(e, val) =>
                    setFormData({
                      ...formData,
                      paymentMethods: val?.value || "",
                    })
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Payment Method"
                      required
                      InputLabelProps={{
                        sx: {
                          "& .MuiInputLabel-asterisk": {
                            color: "red",
                          },
                        },
                      }}
                      error={!!formErrors.paymentMethods}
                      helperText={formErrors.paymentMethods}
                    />
                  )}
                />
              </Grid>

              {/* Conditional Fields */}
              {formData.paymentMethods === "cheque" && (
                <>
                  {/* Cheque Number */}
                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      required
                      type="number"
                      label="Cheque Number Against This Bill"
                      name="chequeNumber"
                      value={formData.chequeNumber}
                      onChange={handleChange}
                      sx={{
                        flex: 1,
                        "& input[type=number]::-webkit-inner-spin-button": {
                          display: "none",
                        },
                        "& input[type=number]::-webkit-outer-spin-button": {
                          display: "none",
                        },
                        "& input[type=number]": {
                          MozAppearance: "textfield",
                        },
                      }}
                      InputLabelProps={{
                        sx: {
                          "& .MuiInputLabel-asterisk": {
                            color: "red",
                          },
                        },
                      }}
                      error={!!formErrors.chequeNumber}
                      helperText={formErrors.chequeNumber}
                    />
                  </Grid>

                  {/* Cheque Date */}
                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      required
                      type="date"
                      label="Cheque Date"
                      name="chequeDate"
                      value={formData.chequeDate}
                      onChange={handleChange}
                      // InputLabelProps={{ shrink: true }}
                      InputLabelProps={{
                        shrink: true,
                        sx: {
                          "& .MuiInputLabel-asterisk": {
                            color: "red",
                          },
                        },
                      }}
                      inputProps={{
                        max: new Date().toISOString().split("T")[0],
                      }}
                      error={!!formErrors.chequeDate}
                      helperText={formErrors.chequeDate}
                    />
                  </Grid>
                </>
              )}

              {formData.paymentMethods === "bankTransfer" && (
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    required
                    label="UTR Number"
                    name="bankUTRNo"
                    value={formData.bankUTRNo}
                    onChange={handleChange}
                    InputLabelProps={{
                      sx: {
                        "& .MuiInputLabel-asterisk": {
                          color: "red",
                        },
                      },
                    }}
                    error={!!formErrors.bankUTRNo}
                    helperText={formErrors.bankUTRNo}
                  />
                </Grid>
              )}

              {formData.paymentMethods === "upi" && (
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    required
                    label="UPI Reference Number"
                    name="UPIReferenceNumber"
                    value={formData.UPIReferenceNumber}
                    onChange={handleChange}
                    InputLabelProps={{
                      sx: {
                        "& .MuiInputLabel-asterisk": {
                          color: "red",
                        },
                      },
                    }}
                    error={!!formErrors.UPIReferenceNumber}
                    helperText={formErrors.UPIReferenceNumber}
                  />
                </Grid>
              )}

              {/* Transaction Amount */}
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  required
                  label="Transaction Amount Received in Bank"
                  name="transactionAmountReceivedInBank"
                  value={formData.transactionAmountReceivedInBank}
                  onChange={handleChange}
                  InputLabelProps={{
                    sx: {
                      "& .MuiInputLabel-asterisk": {
                        color: "red",
                      },
                    },
                  }}
                  error={!!formErrors.transactionAmountReceivedInBank}
                  helperText={formErrors.transactionAmountReceivedInBank}
                />
              </Grid>

              {/* Bank Account (Dropdown) */}
              {/* <Grid item xs={12}>
                <Autocomplete
                  options={bankAccounts}
                  getOptionLabel={(option) => option.label}
                  onChange={(e, val) =>
                    setFormData({
                      ...formData,
                      jobizoBankName: val?.value || "",
                    })
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Bank Account"
                      required
                      InputLabelProps={{
                        sx: {
                          "& .MuiInputLabel-asterisk": {
                            color: "red",
                          },
                        },
                      }}
                      error={!!formErrors.jobizoBankName}
                      helperText={formErrors.jobizoBankName}
                    />
                  )}
                />
              </Grid> */}
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Bank Name"
                  name="jobizoBankName"
                  value={formData.jobizoBankName}
                  disabled
                />
              </Grid>

              {/* TDS Amount */}
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  required
                  type="number"
                  label="TDS Amount"
                  name="TDSAmount"
                  value={formData.TDSAmount}
                  onChange={handleChange}
                  sx={{
                    flex: 1,
                    "& input[type=number]::-webkit-inner-spin-button": {
                      display: "none",
                    },
                    "& input[type=number]::-webkit-outer-spin-button": {
                      display: "none",
                    },
                    "& input[type=number]": {
                      MozAppearance: "textfield",
                    },
                  }}
                  InputLabelProps={{
                    sx: {
                      "& .MuiInputLabel-asterisk": {
                        color: "red",
                      },
                    },
                  }}
                  error={!!formErrors.TDSAmount}
                  helperText={formErrors.TDSAmount}
                />
              </Grid>

              {/* Narration */}
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  multiline
                  rows={3}
                  label="Bank Narration (Optional)"
                  name="bankNarration"
                  value={formData.bankNarration}
                  onChange={handleChange}
                />
              </Grid>

            
              {/* File Upload */}
                 {formData.paymentMethods === "cheque" && (
              <Grid item xs={12}>
                <Typography variant="subtitle2" gutterBottom>
                  Attachment (PDF/JPG/PNG)
                  <span style={{ color: "red" }}>*</span>
                </Typography>

                <Box
                  component="label"
                  htmlFor="fileInput"
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    border: "2px dashed #d0d7de",
                    borderRadius: "8px",
                    p: 4,
                    cursor: "pointer",
                    backgroundColor: "#fafafa",
                    transition: "all 0.2s ease-in-out",
                    "&:hover": {
                      backgroundColor: "#f0f4ff",
                      borderColor: "#1976d2",
                    },
                    position: "relative",
                  }}
                >
                  {!formData.attachmentURL &&
                  !billData?.offlineBillDetails?.attachmentURL ? (
                    <>
                      <CloudUploadIcon
                        sx={{ fontSize: 40, color: "#1976d2", mb: 1 }}
                      />
                      <Typography
                        variant="body1"
                        sx={{ color: "#444", fontWeight: 500 }}
                      >
                        Click to upload payment proof
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{ color: "text.secondary", mt: 0.5 }}
                      >
                        PDF, JPG, PNG up to 10MB
                      </Typography>
                      {formErrors.attachmentURL && (
                        <Typography
                          variant="body2"
                          sx={{ color: "red", mt: 1 }}
                        >
                          {formErrors.attachmentURL}
                        </Typography>
                      )}
                    </>
                  ) : (
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                      }}
                    >
                      <Typography variant="body1" sx={{ mb: 1 }}>
                        Uploaded:{" "}
                        {formData?.attachment?.name ||
                          billData?.offlineBillDetails?.attachmentURL
                            ?.split("/")
                            ?.pop()}
                      </Typography>
                      <Box sx={{ display: "flex", gap: 1 }}>
                        {completePayment !== 0 && (
                          <Button
                            variant="outlined"
                            size="small"
                            onClick={(e) => {
                              e.stopPropagation();
                              document.getElementById("fileInput").click();
                            }}
                            sx={{
                              backgroundColor: "#fff",
                              color: "#000",
                              borderColor: "#ccc",
                              ":hover": {
                                backgroundColor: "#f5f5f5",
                                borderColor: "#999",
                              },
                            }}
                          >
                            Change
                          </Button>
                        )}

                        <Button
                          variant="contained"
                          size="small"
                          onClick={(e) => {
                            e.stopPropagation();
                            window.open(
                              formData.attachmentURL ||
                                billData?.offlineBillDetails?.attachmentURL,
                              "_blank"
                            );
                          }}
                        >
                          View
                        </Button>
                      </Box>
                    </Box>
                  )}

                  <input
                    type="file"
                    id="fileInput"
                    name="attachmentURL"
                    hidden
                    accept=".pdf,.jpg,.jpeg,.png"
                    onChange={handleChange}
                  />
                </Box>
              </Grid>
                 )}

              {/* <Grid item xs={12}>
                <Typography variant="subtitle2" gutterBottom>
                  Attachment (PDF/JPG/PNG)
                  <span style={{ color: "red" }}>*</span>
                </Typography>

                <Box
                  component="label"
                  htmlFor="fileInput"
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    border: "2px dashed #d0d7de",
                    borderRadius: "8px",
                    p: 4,
                    cursor: "pointer",
                    backgroundColor: "#fafafa",
                    transition: "all 0.2s ease-in-out",
                    "&:hover": {
                      backgroundColor: "#f0f4ff",
                      borderColor: "#1976d2",
                    },
                    position: "relative",
                  }}
                >
                  {!formData.attachmentURL ? (
                    <>
                      <CloudUploadIcon
                        sx={{ fontSize: 40, color: "#1976d2", mb: 1 }}
                      />
                      <Typography
                        variant="body1"
                        sx={{ color: "#444", fontWeight: 500 }}
                      >
                        Click to upload payment proof
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{ color: "text.secondary", mt: 0.5 }}
                      >
                        PDF, JPG, PNG up to 10MB
                      </Typography>
                      {formErrors.attachmentURL && (
                        <Typography
                          variant="body2"
                          sx={{ color: "red", mt: 1 }}
                        >
                          {formErrors.attachmentURL}
                        </Typography>
                      )}
                    </>
                  ) : (
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                      }}
                    >
                      <Typography variant="body1" sx={{ mb: 1 }}>
                        Uploaded: {formData.attachment.name}
                      </Typography>
                      <Box sx={{ display: "flex", gap: 1 }}>
                        <Button
                          variant="outlined"
                          size="small"
                          onClick={(e) => {
                            e.stopPropagation();
                            document.getElementById("fileInput").click();
                          }}
                          sx={{
                            backgroundColor: "#fff",
                            color: "#000",
                            borderColor: "#ccc",
                            ":hover": {
                              backgroundColor: "#f5f5f5",
                              borderColor: "#999",
                            },
                          }}
                        >
                          Change
                        </Button>
                        <Button
                          variant="contained"
                          size="small"
                          onClick={(e) => {
                            e.stopPropagation();
                            window.open(formData.attachmentURL, "_blank");
                          }}
                        >
                          View
                        </Button>
                      </Box>
                    </Box>
                  )}

                  <input
                    type="file"
                    id="fileInput"
                    name="attachmentURL"
                    hidden
                    accept=".pdf,.jpg,.jpeg,.png"
                    onChange={handleChange}
                  />
                </Box>
              </Grid> */}

              {/* Buttons */}
              <Grid
                item
                xs={12}
                display="flex"
                justifyContent="flex-end"
                gap={2}
              >
                <Button
                  variant="outlined"
                  //   startIcon={<CancelIcon />}
                  sx={{
                    backgroundColor: "#fff",
                    color: "#000",
                    borderColor: "#ccc",
                    ":hover": {
                      backgroundColor: "#f5f5f5",
                      borderColor: "#999",
                    },
                  }}
                  onClick={handleClosePayment}
                >
                  Cancel
                </Button>

                <Button
                  type="submit"
                  variant="contained"
                  //   startIcon={<CheckCircleIcon />}
                  disabled={
                    completePayment === 0 ||
                    formData.amountReceivedAgainstBill > formData.totalAmount
                  }
                  sx={{
                    backgroundColor: "#1976d2", // normal blue
                    ":hover": { backgroundColor: "#1565c0" }, // darker blue on hover
                  }}
                >
                  Submit Payment
                </Button>
              </Grid>
            </Grid>
          </form>
        </Paper>
      </DialogContent>
    </Dialog>
  );
};

export default AddPayment;
